import {InstancesController} from "./instances.controller.js";
import {InstanceFormController} from "./instance_form.controller.js";

function instancesConfig ($stateProvider) {

    $stateProvider
        .state('settings.instances', {
            url: '/instances',
            template: require('./instances.html'),
            controller: 'InstancesController as Instances',
            params: {
                title: 'Instances'
            }
        })
        .state('settings.instances.new', {
            url: '/instances/new',
            parent: 'settings',
            templateUrl: 'states/settings/tabs/instances/instance_form.html',
            controller: 'InstanceFormController as InstanceForm',
            params: {
                title: 'Add Instance'
            }
        })
        .state('settings.instances.edit', {
            url: '/instances/{instanceID}/edit',
            parent: 'settings',
            templateUrl: 'states/settings/tabs/instances/instance_form.html',
            controller: 'InstanceFormController as InstanceForm',
            params: {
                title: 'Edit Instance'
            }
        })

}

export default angular.module('instances', [])
    .config(instancesConfig)
    .controller('InstancesController', InstancesController)
    .controller('InstanceFormController', InstanceFormController)



// WEBPACK FOOTER //
// ./modules/xray/states/settings/tabs/instances/instances.module.js